import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { colourStyles } from 'utils/selectStyle'
import iconRemove from 'images/remove-gray.svg'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Form from 'component/utils/Form'
import InputNumberAutoFormat from 'component/form/InputNumberAutoFormat'
import Row from 'component/utils/Row'

const FIELDS = [
  'cdNewDynamic',
  'cdParcel',
  'dsNewDynamic',
  'prMaxValue',
  'prMinValue',
]

const ParcelRangeForm = ({
  dynamicList,
  fields,
  parcelList,
  onChange,
  onClickRemoveButton,
  setValueToField,
  showRemoveButton,
  translate,
  values,
  fieldsHighlight,
}) => {
  const handleChange = (field, value) => {
    setValueToField(field, value)

    onChange(values)
  }

  return (
    <Row className='pricebanner-config-modal-parcel-range-form'>
      <Col xs={12} lg={2}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.cdParcelLabel')}
          </strong>
        </div>
        <Field {...fields.cdParcel}>
          <Select
            {...fields.cdParcel.input}
            classNamePrefix='react-select'
            onChange={(option) =>
              handleChange(fields.cdParcel.input.name, option.value)
            }
            options={parcelList}
            placeholder={translate(
              'config.pricebannerConfig.form.cdParcelLabel'
            )}
            styles={colourStyles}
            value={parcelList.find((i) => i.value === values.cdParcel)}
            className={
              fieldsHighlight.cdParcel === 1
                ? 'react-select highlight'
                : 'react-select'
            }
          />
        </Field>
      </Col>
      <Col xs={12} lg={3}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.prMinValue')}
          </strong>
        </div>
        <Field {...fields.prMinValue}>
          <InputNumberAutoFormat
            {...fields.prMinValue.input}
            delimiter={translate('delimiter.currency')}
            maxLength={9}
            onChange={(event) =>
              handleChange(fields.prMinValue.input.name, event.target.value)
            }
            placeholder={translate('config.pricebannerConfig.form.prMinValue')}
            separator={translate('separator.currency')}
            className={fieldsHighlight.prMinValue === 1 ? 'highlight' : ''}
          />
        </Field>
      </Col>
      <Col xs={12} lg={3}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.prMaxValue')}
          </strong>
        </div>
        <Field {...fields.prMaxValue}>
          <InputNumberAutoFormat
            {...fields.prMaxValue.input}
            delimiter={translate('delimiter.currency')}
            maxLength={9}
            onChange={(event) =>
              handleChange(fields.prMaxValue.input.name, event.target.value)
            }
            placeholder={translate('config.pricebannerConfig.form.prMaxValue')}
            separator={translate('separator.currency')}
            className={fieldsHighlight.prMaxValue === 1 ? 'highlight' : ''}
          />
        </Field>
      </Col>
      <Col xs={12} lg={4} className='relative'>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.cdNewDynamic')}
          </strong>
        </div>
        <Field {...fields.cdNewDynamic}>
          <Select
            {...fields.cdNewDynamic.input}
            className='react-select'
            classNamePrefix='react-select'
            onChange={(option) => {
              handleChange(fields.cdNewDynamic.input.name, option.value)
              handleChange(fields.dsNewDynamic.input.name, option.label)
            }}
            options={dynamicList}
            placeholder={translate(
              'config.pricebannerConfig.form.cdDynamicLabel2'
            )}
            styles={colourStyles}
            value={dynamicList.find((i) => i.value === values.cdNewDynamic)}
          />
        </Field>
        {showRemoveButton && (
          <img
            onClick={onClickRemoveButton}
            src={iconRemove}
            className='pricebanner-config-remove'
          />
        )}
      </Col>
    </Row>
  )
}

ParcelRangeForm.propTypes = {
  dynamicList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClickRemoveButton: PropTypes.func.isRequired,
  parcelList: PropTypes.array.isRequired,
  setValueToField: PropTypes.func.isRequired,
  showRemoveButton: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  fieldsHighlight: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(ParcelRangeForm)
